module.exports = __webpack_public_path__ + "img/nbus_main_titleback.4ec473cb.jpg";